import { DatePicker } from "antd";
import { Dayjs } from "dayjs";
import React from "react";

const { RangePicker } = DatePicker;

interface AppRangePickerProps {
  label: string;
  onChange: (
    dates: [Dayjs | null, Dayjs | null] | null,
    dateStrings: [string, string] | null
  ) => void;
  placeHolder?: string;
}

const AppRangePicker: React.FC<AppRangePickerProps> = ({
  label,
  onChange,
  placeHolder = "",
  ...rest
}) => {
  return (
    <div className="app-select-filter">
      <label className="app-select-filter-label">{label}</label>
      <RangePicker
        style={{ height: "44px", marginTop: "5px" }}
        onChange={(dates, dateStrings) => onChange(dates, dateStrings)}
        placeholder={
          placeHolder ? [placeHolder, placeHolder] : ["Start Date", "End Date"]
        }
        {...rest}
      />
    </div>
  );
};

export default AppRangePicker;
